import React from "react";

import s from "./primitive.module.scss";
import { DivPx } from "@moai/core";

type Value = boolean | number | string | null;

interface Props {
    name?: string;
    node: Value;
}

export const isPrimitive = (value: any): value is Value => {
    if (value === null) return true;
    return ["boolean", "number", "string"].includes(typeof value);
};

const getCls = (value: Value) => (value === null ? s.null : s[typeof value]);

const getString = (value: Value): string => {
    if (value === null) return "null";
    switch (typeof value) {
        case "boolean":
            return value ? "true" : "false";
        case "number":
            return value.toString();
        case "string":
            return `"${value}"`;
    }
};

export const PrimitiveNode: React.FC<Props> = ({ name, node: value }) => (
    <div className={s.container}>
        {name && (
            <>
                <div className={s.name}>{name}:</div>
                <DivPx size={8} />
            </>
        )}
        <div className={getCls(value)}>{getString(value)}</div>
    </div>
);
